module.exports = __webpack_public_path__ + "img/instagram.395c8d9e.svg";